module.exports = __webpack_public_path__ + "static/media/Kissen_50x50.d469590a.png";